import { PROTO } from '@/constants/testIds/healthspan';

const MAP = {
  meta_analysis: { label: 'Meta-analysis', cls: 'bg-[color:rgba(46,139,87,0.12)] text-[color:var(--success)] border-[color:rgba(46,139,87,0.35)]' },
  RCT: { label: 'RCT', cls: 'bg-[color:rgba(46,139,87,0.12)] text-[color:var(--success)] border-[color:rgba(46,139,87,0.35)]' },
  human_observational: { label: 'Human observational', cls: 'bg-[color:rgba(0,166,166,0.12)] text-[color:var(--accent-teal)] border-[color:rgba(0,166,166,0.35)]' },
  mouse_study: { label: 'Mouse study', cls: 'bg-[color:rgba(216,155,0,0.14)] text-[color:var(--warning)] border-[color:rgba(216,155,0,0.35)]' },
  in_vitro: { label: 'In vitro', cls: 'bg-[color:rgba(184,194,204,0.18)] text-[color:var(--muted-fg)] border-[color:rgba(184,194,204,0.35)]' },
};

export default function EvidenceBadge({ level }) {
  const v = MAP[level] || { label: level, cls: 'bg-[color:var(--surface-2)] text-[color:var(--muted-fg)] border-[color:var(--border-color)]' };
  return (
    <span data-testid={PROTO.evidenceBadge} title={`Evidence tier: ${v.label}`} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium tracking-wide ${v.cls}`}>
      {v.label}
    </span>
  );
}
